export const VSA_DEFAULT_VALUE = {
  //Responses observer state from KITT
  vehicleInspectionDetailsResponse: "",
  certifyRepairsResponse: "",
  submitInspectionReportResponse: "",

  //KITT response data
  vehicleInspectionDetails: "",

  //VehicleDetails data destructure
  vehicleInspectionTemplate: "",
  vehicleIssues: "",
  vehicleData: "",
  vin: "",

  //Generated reports for VSA
  report: "",
  reportThumbnails: "",

  //Indexes for VSA
  currentMoveToLocationIndex: 0,
  currentCategoryIndex: 0,

  //Current checklistItem selected for Picture Taking
  currentTakePhotoChecklistItem: null,

  //Inspection start time in milliseconds
  inspectionStartTime: null,
};

export const VSAContextActions = {
  UPDATE_VEHICLE_INSPECTION_DETAILS: "UPDATE_VEHICLE_INSPECTION_DETAILS",
  UPDATE_VEHICLE_INSPECTION_DETAILS_RESPONSE:
    "UPDATE_VEHICLE_INSPECTION_DETAILS_RESPONSE",
  UPDATE_CERTIFY_REPAIRS_RESPONSE: "UPDATE_CERTIFY_REPAIRS_RESPONSE",
  UPDATE_SUBMIT_INSPECTION_REPORT_RESPONSE:
    "UPDATE_SUBMIT_INSPECTION_REPORT_RESPONSE",
  UPDATE_VEHICLE_INSPECTION_TEMPLATE: "UPDATE_VEHICLE_INSPECTION_TEMPLATE",
  UPDATE_VEHICLE_ISSUES: "UPDATE_VEHICLE_ISSUES",
  UPDATE_VEHICLE_DATA: "UPDATE_VEHICLE_DATA",
  UPDATE_VIN: "UPDATE_VIN",
  UPDATE_REPORT: "UPDATE_REPORT",
  UPDATE_REPORT_THUMBNAILS: "UPDATE_REPORT_THUMBNAILS",
  INCREMENT_MOVE_TO_LOCATION_INDEX: "INCREMENT_MOVE_TO_LOCATION_INDEX",
  DECREMENT_MOVE_TO_LOCATION_INDEX: "DECREMENT_MOVE_TO_LOCATION_INDEX",
  UPDATE_MOVE_TO_LOCATION_INDEX: "UPDATE_MOVE_TO_LOCATION_INDEX",
  INCREMENT_CURRENT_CATEGORY_INDEX: "INCREMENT_CURRENT_CATEGORY_INDEX",
  DECREMENT_CURRENT_CATEGORY_INDEX: "DECREMENT_CURRENT_CATEGORY_INDEX",
  UPDATE_CURRENT_CATEGORY_INDEX: "UPDATE_CURRENT_CATEGORY_INDEX",
  RESET_CURRENT_CATEGORY_INDEX: "RESET_CURRENT_CATEGORY_INDEX",
  UPDATE_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM:
    "UPDATE_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM",
  RESET_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM:
    "RESET_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM",
  SET_INSPECTION_START_TIME: "SET_INSPECTION_START_TIME",
};

export const VSAContextReducer = (state, action) => {
  switch (action.type) {
    case VSAContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS:
      return { ...state, vehicleInspectionDetails: action.value };
    case VSAContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS_RESPONSE:
      return { ...state, vehicleInspectionDetailsResponse: action.value };
    case VSAContextActions.UPDATE_CERTIFY_REPAIRS_RESPONSE:
      return { ...state, certifyRepairsResponse: action.value };
    case VSAContextActions.UPDATE_SUBMIT_INSPECTION_REPORT_RESPONSE:
      return { ...state, submitInspectionReportResponse: action.value };
    case VSAContextActions.UPDATE_VEHICLE_INSPECTION_TEMPLATE:
      return { ...state, vehicleInspectionTemplate: action.value };
    case VSAContextActions.UPDATE_VEHICLE_ISSUES:
      return { ...state, vehicleIssues: action.value };
    case VSAContextActions.UPDATE_VEHICLE_DATA:
      return { ...state, vehicleData: action.value };
    case VSAContextActions.UPDATE_VIN:
      return { ...state, vin: action.value };
    case VSAContextActions.UPDATE_REPORT:
      return { ...state, report: action.value };
    case VSAContextActions.UPDATE_REPORT_THUMBNAILS:
      return { ...state, reportThumbnails: action.value };
    case VSAContextActions.INCREMENT_MOVE_TO_LOCATION_INDEX:
      return {
        ...state,
        currentMoveToLocationIndex: state.currentMoveToLocationIndex + 1,
      };
    case VSAContextActions.DECREMENT_MOVE_TO_LOCATION_INDEX:
      return {
        ...state,
        currentMoveToLocationIndex: state.currentMoveToLocationIndex - 1,
      };
    case VSAContextActions.UPDATE_MOVE_TO_LOCATION_INDEX:
      return {
        ...state,
        currentMoveToLocationIndex: action.value,
      };
    case VSAContextActions.INCREMENT_CURRENT_CATEGORY_INDEX:
      return { ...state, currentCategoryIndex: state.currentCategoryIndex + 1 };
    case VSAContextActions.DECREMENT_CURRENT_CATEGORY_INDEX:
      return { ...state, currentCategoryIndex: state.currentCategoryIndex - 1 };
    case VSAContextActions.UPDATE_CURRENT_CATEGORY_INDEX:
      return { ...state, currentCategoryIndex: action.value };
    case VSAContextActions.RESET_CURRENT_CATEGORY_INDEX:
      return { ...state, currentCategoryIndex: 0 };
    case VSAContextActions.UPDATE_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM:
      return { ...state, currentTakePhotoChecklistItem: action.value };
    case VSAContextActions.RESET_CURRENT_TAKE_PHOTO_CHECKLIST_ITEM:
      return { ...state, currentTakePhotoChecklistItem: null };
    case VSAContextActions.SET_INSPECTION_START_TIME:
      return { ...state, inspectionStartTime: Date.now() };
    default:
      return state;
  }
};
